export default "<!-- Check permission -->\n<app-permission-member></app-permission-member>\n\n<!-- Menu bar -->\n<app-menu-bar-member></app-menu-bar-member>\n"